import { createListenerMiddleware } from '@myua/rtk-helper';
// currently prettier (v1.19.1) doesn't support `import type` notation
// on the other hand, current eslint or eslint-plugin-import reports error here
// eslint-disable-next-line import/named
import { ListenerApiSafe } from '../general/listenerMiddlewareAddons';
import { nodeTreeListeners } from '@myua/nodetree';
import { onOpenError } from '../general/modules/treeView/listeners';
import { StoreShape } from './models/rootSelector';
import { appListeners } from './modules/app/listener';
import { breadcrumbsListeners } from './modules/breadcrumbs/listeners';
import { favoriteRootListener } from './modules/favorite/sagas';
import { fileManagerListeners } from './modules/fileManager/sagas';
import { newFolderRootListener } from './modules/newFolder/sagas';
import { permissionModalRootListener } from './modules/permissionModal/sagas';
import { searchListeners } from './modules/search/listeners';
import { TrashRootListener } from './modules/trashPage/sagas';
import { sharingRootListener } from './modules/sharing/sagas';
import { tagRootListener } from './modules/tag/sagas';
import { uploaderRootListener } from './modules/uploader/sagas';
import { sharedLinksListener } from './modules/sharedLinks/sagas';
import { moverListener } from './modules/mover/sagas';
import { sharedLinksRemoverListener } from './modules/sharedLinksRemover/sagas';
import { removerRootListener } from './modules/remover/sagas';
import { renamingRootListener } from './modules/renaming/sagas';
import { downloaderRootListener } from './modules/downloader/sagas';
import { creativeFolderRootListener } from './modules/creativeFolder/sagas';
import { creativeConverterRootListener } from './modules/creativeConverter/sagas';
import { linkExistingFilesRootListener } from './modules/linkExistingFiles';
import { figmaImportRootListener } from './modules/figmaImport/logic';
import { packerRootListener } from './modules/packer/logic';
import { googleBulkListeners } from './modules/googleBulk/listeners';
import { videoMergeListeners } from './modules/videoMerge/listeners';
import { googleDriveImportListeners } from './modules/googleDriveImport/listeners';

export { _fork, _select, _take } from '../general/listenerMiddlewareAddons';
export type ListenerApiLight = ListenerApiSafe<StoreShape>;
export const lm = createListenerMiddleware<StoreShape>();

export function rootListener() {
  appListeners();
  breadcrumbsListeners();
  downloaderRootListener();
  creativeFolderRootListener();
  creativeConverterRootListener();
  linkExistingFilesRootListener();

  favoriteRootListener();
  figmaImportRootListener(lm);
  fileManagerListeners();
  moverListener();
  newFolderRootListener();
  packerRootListener(lm);
  permissionModalRootListener();
  removerRootListener();
  renamingRootListener();
  searchListeners();
  sharedLinksListener();
  sharedLinksRemoverListener();
  sharingRootListener();
  tagRootListener();
  TrashRootListener();
  uploaderRootListener();
  googleBulkListeners();
  videoMergeListeners();
  googleDriveImportListeners();
  nodeTreeListeners.rootListener(lm, onOpenError);
}
